// screens/PricingScreen.jsx
import React from "react";
import Pricing from "../components/Pricing";

const PricingScreen = () => {
  return (
    <main>
      <Pricing />
    </main>
  );
};

export default PricingScreen;